export default "__VITE_ASSET__CW2m1Q4O__"